export default __webpack_public_path__ + "static/appStore-6ed7129800eced0517b890f9f8513eab.png";